import { render } from "./MyPageQuotationList.vue?vue&type=template&id=a06226a0"
const script = {}

import "./MyPageQuotationList.vue?vue&type=style&index=0&id=a06226a0&lang=css"

import exportComponent from "D:\\curProject\\newTrip\\client\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__